import { Form, Formik } from "formik";
import { FilledButtonStyle } from "../../styles/common.style";
import InputBox from "../InputBox/InputBox";
import { ContactFooter, LogoWithHeading } from "../LogoWithHeading";
import { LoginFormStyle } from "./LoginForm.style";
import { LoginFormValidationSchema } from "./validations";

const LoginForm = () => {

  const handleFormSubmit = async (values: { remember: boolean }) => {
    const domain = process.env.REACT_APP_AUTH0_DOMAIN;
    const client_id = process.env.REACT_APP_AUTH0;
    const audience = process.env.REACT_APP_AUTH0_AUDIENCE;
    const scope = "openid profile email";
    const response_type = "token";
    const redirect_uri = `${window.location.origin}/shift`;

    if (!domain || !client_id || !audience || !redirect_uri) {
      throw new Error("Auth0 configuration is missing. Please check environment variables.");
    }

    // Build Auth0 authorization URL
    let authUrl = `https://${domain}/authorize?` +
      `audience=${audience}&` +
      `scope=${scope}&` +
      `response_type=${response_type}&` +
      `client_id=${client_id}&` +
      `redirect_uri=${redirect_uri}`;

    // Use max_age parameter to persist session across browser closes when "Remember me" is checked
    // max_age is in seconds:
    // - No max_age (default): session expires when browser closes
    // - 30 days = 2592000 seconds: session persists for 30 days
    if (values.remember) {
      authUrl += `&max_age=2592000`; // 30 days in seconds
    }

    window.location.replace(authUrl);
  };

  const Mailto = ({ email, subject = "", body = "", children }) => {
    let params = subject || body ? "?" : "";
    if (subject) params += `subject=${encodeURIComponent(subject)}`;
    if (body) params += `${subject ? "&" : ""}body=${encodeURIComponent(body)}`;

    return <a href={`mailto:${email}${params}`}>{children}</a>;
  };

  return (
    <LoginFormStyle>
      <LogoWithHeading
        heading="Sign into your account"
        description="For curators, artists and labels."
      />
      <Formik
        initialValues={{ email: "", password: "", remember: false }}
        onSubmit={(values) => handleFormSubmit(values)}
        validationSchema={LoginFormValidationSchema}
      >
        {({ values, errors }) => (
          <Form className="form-wrapper">
            <div>
              <div className="input-wrapper">
                <InputBox
                  label="Email"
                  type="email"
                  name="email"
                  error={errors.email}
                  transparent
                />
                <InputBox
                  label="Password"
                  type="password"
                  name="password"
                  error={errors.password}
                  transparent
                />
              </div>
              <Mailto
                email="info@soarmusicgroup.com"
                subject="Forgot password - Songplace"
                body=""
              >
                <p className="link">Forgot password? Contact us</p>
              </Mailto>
            </div>

            <span className="remember-me">
              <InputBox
                name="remember"
                className="remember-me"
                type="checkbox"
              />
              <label>Remember me</label>
            </span>

            <div className="button-wrapper">
              <FilledButtonStyle type="submit">Log in</FilledButtonStyle>
            </div>
          </Form>
        )}
      </Formik>
      <ContactFooter />
    </LoginFormStyle>
  );
};

export default LoginForm;
